import {CancelBoxRepository, CancelBoxResult} from '@domain/model/Order/CancelBox/CancelBoxRepository';
import {request} from '@infra/api/fetch/request';

export type BoxRevokeWarningCode = 'REFUND_FAILED' | 'BOX_ALREADY_REFUNDED';
export type BoxRevokeFailCode = 'CANCEL_NOT_ALLOWED' | 'ERR_NOT_CURRENT_BOX';

export interface BoxRevokeOkResponse {
  status: 'ok';
}

export interface BoxRevokeWarningResponse {
  status: 'warning';
  data: {
    code: BoxRevokeWarningCode;
    msg: string;
  };
}

export interface BoxRevokeFailResponse {
  status: 'fail';
  data: {
    code?: BoxRevokeFailCode;
    msg: string;
  };
}

export type BoxRevokeResponse = BoxRevokeOkResponse | BoxRevokeWarningResponse | BoxRevokeFailResponse;

export const ApiCancelBoxRepository: CancelBoxRepository = {
  cancelBox: async (): Promise<CancelBoxResult> => {
    try {
      const response = await request<BoxRevokeResponse>({url: `/web/api/box/revoke`, method: 'POST'});

      if (response.status === 'fail') {
        return {outcome: 'error'};
      }

      return {outcome: 'success'};
    } catch {
      return {outcome: 'error'};
    }
  },
};
